import { useQueryClient } from '@tanstack/react-query';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
import { revenueOpportunitiesSummaryKey } from '~/utils/revenueOpportunities/revenueOpportunitiesQueryKeys';
export const useUndoRevenueOpportunityDismissal = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutateAsync } = useMutationState({
        mutationFn: (param)=>{
            let { dismissalIds } = param;
            return Promise.allSettled(dismissalIds.map((id)=>api.pulse.deleteDismissal(id))).then((results)=>results.filter((param)=>{
                    let { status } = param;
                    return status === 'rejected';
                }).length);
        },
        onSuccess: (failedCount, param)=>{
            let { dismissalIds, businessId } = param;
            if (failedCount < dismissalIds.length) {
                queryClient.invalidateQueries({
                    queryKey: revenueOpportunitiesSummaryKey(businessId)
                });
            }
        }
    });
    return {
        undoRevenueOpportunityDismissal: mutateAsync
    };
};
